/**
 * Created by olga on 27.01.2025
 */

cleverapps.InitByType["differences"] = function () {
    cleverapps.tutorial.register(PhotosTutorial());
};